<template>
    <div>
        <router-link tag="a" class="back-button right mb11" to="/portfolio">Back to portfolio</router-link>
        <h6 class="headline-sm">COMMUNITY PROJECTS</h6>
        <ul class="portfolio-list">
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community1.png" alt="">
                <strong class="portfolio-list-name">Baltimore Harbor</strong>
                <span class="portfolio-list-location">Baltimore, MD</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community2.png" alt="">
                <strong class="portfolio-list-name">Basque Center</strong>
                <span class="portfolio-list-location">Boise, ID</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community3.png" alt="">
                <strong class="portfolio-list-name">Idaho Elks Hospital</strong>
                <span class="portfolio-list-location">Boise, ID</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community4.png" alt="">
                <strong class="portfolio-list-name">The Grove Plaza</strong>
                <span class="portfolio-list-location">Boise, ID</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community5.png" alt="">
                <strong class="portfolio-list-name">Boothbay Animal Hospital</strong>
                <span class="portfolio-list-location">Boothbay Harbor, ME</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community6.png" alt="">
                <strong class="portfolio-list-name">Boothbay Harbor</strong>
                <span class="portfolio-list-location">Boothbay Harbor, ME</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community7.png" alt="">
                <strong class="portfolio-list-name">Hospice of Gunnison Valley</strong>
                <span class="portfolio-list-location">Gunnison, CO </span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community8.png" alt="">
                <strong class="portfolio-list-name">Medford Lakes 9/11 Memorial</strong>
                <span class="portfolio-list-location">Medford Lakes, NJ</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community9.png" alt="">
                <strong class="portfolio-list-name">Basque Association</strong>
                <span class="portfolio-list-location">Mountain Home, ID</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community10.png" alt="">
                <strong class="portfolio-list-name">Friends of Hospice</strong>
                <span class="portfolio-list-location">Nevada City, CA</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community11.png" alt="">
                <strong class="portfolio-list-name">Norquay 100 Committee</strong>
                <span class="portfolio-list-location">Norquay, Saskatchewan, Canada</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community12.png" alt="">
                <strong class="portfolio-list-name">San Francisco Zoo</strong>
                <span class="portfolio-list-location">San Francisco, CA</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community13.png" alt="">
                <strong class="portfolio-list-name">Noe Valley Recreation Center</strong>
                <span class="portfolio-list-location">San Francisco, CA</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community14.png" alt="">
                <strong class="portfolio-list-name">The Club at Savannah Harbor</strong>
                <span class="portfolio-list-location">Savannah, GA</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community15.png" alt="">
                <strong class="portfolio-list-name">Star Lions Club</strong>
                <span class="portfolio-list-location">Star, ID</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Community-Projects/community16.png" alt="">
                <strong class="portfolio-list-name">Downtown Revitalization</strong>
                <span class="portfolio-list-location">Washington, MO</span>
            </li>
        </ul>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'communityProjects',
        metaInfo: {
            title: 'Community Projects'
        }
    }
</script>



// WEBPACK FOOTER //
// CommunityProjects.vue?ec175a00